import React from "react";
import styles from "./AssetDeviceCard.module.scss";
import StatusIndicator from "./../StatusIndicator";
import moment from "moment";
import {
  SENTINEL_MOBILE_TRACKER,
  SENTINEL_MOBILE,
} from "../../constants/sentinel_types";
import { INACTIVE_EXPIRED_LICENSE } from "../../constants/statuses";
import Icon from "../Icon";
import getStatus from "../../helpers/statuses";
import Label from "../Label";
import InputRow from "../InputRow";
export default function AssetDeviceCard({
  device,
  asset,
  groups,
  license = null,
  signal = null,
  battery = null,
  temperature = null,
  firmware = null,
}) {
  const displayLicenceSimple = (license) => {
    return license
      ? moment.utc(license?.expiry_date).format("MMM Do YYYY")
      : "N/A";
  };

  const sentinelMobile =
    device?.devicetype_id === SENTINEL_MOBILE ||
    device?.devicetype_id === SENTINEL_MOBILE_TRACKER;
  return (
    <div className={styles.deviceCard}>
      {/* Header row: Serial number on the left, icons on the right */}
      <InputRow>
        <Label text="Serial number" theme="light">
          {device.serial_number || "N/A"}
        </Label>

        <Label text="Expiration" theme="light">
          {displayLicenceSimple(license)}
        </Label>
      </InputRow>
      <div className={styles.break} />
      <InputRow>
        <Label text="Status" theme="light">
          <div className={styles.wrapvertStatus}>
            {device.status === INACTIVE_EXPIRED_LICENSE ? (
              <span className={styles.danger}>
                {getStatus(device.status).name}
              </span>
            ) : (
              <>
                <StatusIndicator status={device.status} size="20px" />
                {getStatus(device.status).name}
              </>
            )}
          </div>
        </Label>
        <Label text="Notifications" theme="light">
          <div className={styles.wrapvertStatus}>
            <Icon
              padding={0}
              name={
                asset?.maintenance ? "notifications_off" : "notifications_none"
              }
            />
            {asset?.maintenance ? "Disabled" : "Enabled"}
          </div>
        </Label>

        {sentinelMobile && (
          <Label text="Deployment" theme="light">
            <div className={styles.wrapvertStatus}>
              <StatusIndicator
                status={asset?.deployed ? "DEPLOYED" : "NOT_DEPLOYED"}
                size="20px"
              />

              {asset?.deployed ? "Deployed" : "Not deployed"}
            </div>
          </Label>
        )}
      </InputRow>
      <InputRow>
        <Label text="Groups" theme="light">
          {groups}
        </Label>
      </InputRow>
      {device && (
        <>
          <div className={styles.break} />
          <div className={styles.deviceCardIcons}>
            {signal && <div className={styles.icon}>{signal}</div>}
            {battery && <div className={styles.icon}>{battery}</div>}
            {temperature && <div className={styles.icon}>{temperature}</div>}
            {firmware && <div className={styles.icon}>{firmware}</div>}
          </div>
        </>
      )}
    </div>
  );
}
